<script>
  import Icon from "./Icon.svelte";
  let note = true;
  const hideNote = () => {
    note = !note;
  };
</script>

<section id="intro">
  <div class="intro--text add-arrow">
    {#if note}
      <div class="note" on:click={hideNote} role="button" tabindex="0" on:keyup={hideNote}>
        <h3>18-11-2024 - Attenzione!</h3>
        <p>Il bot che andava alla ricerca di news è fermo, non ci saranno più aggiornamenti!</p>
      </div>
    {/if}
    <p>Il 2024 è iniziato con due donne ai vertici dei due più importanti partiti di governo e opposizione.<br /><br />Siamo curiosi di capire come i media parlano di loro.</p>
  </div>
  <div class="intro--image image-1">
    <div class="image">
      <Icon src="meloni" sentiment="meloni" />
    </div>
  </div>
  <div class="intro--image image-2">
    <div class="image">
      <Icon src="schlein" sentiment="schlein" />
    </div>
  </div>
  <div class="intro--image image-3">
    <div class="image">
      <header>
        <h2>Giorgia Meloni</h2>
        <h3>Fratelli d'Italia</h3>
      </header>
    </div>
  </div>
  <div class="intro--image image-4">
    <div class="image">
      <header>
        <h2>Elly Schlein</h2>
        <h3>Partito Democratico</h3>
      </header>
    </div>
  </div>
  <div class="intro--text text-2 add-arrow">
    <p>Per farlo, abbiamo iniziato a raccogliere le news che le citano e usando l'AI abbiamo provato ad interpretarne i toni. Ogni news è stata quindi classificata come <strong class="positive">positiva</strong>, <strong class="negative">negativa</strong> o <strong class="neutral">neutra</strong>.<br /><br />Vediamo assieme cosa abbiamo ottenuto, questo è…</p>
  </div>
</section>

<style>
  #intro {
    display: block;
    margin: 0;
    position: relative;
    width: auto;
  }

  .intro--image,
  .intro--text {
    align-items: center;
    background: var(--light);
    display: flex;
    height: 100vh;
    justify-content: center;
    margin: 0;
    padding: 20px 40px;
    position: sticky;
    top: 0;
  }

  p {
    text-align: center;
  }

  .intro--image {
    height: 50vh;
    overflow: hidden;
  }

  .intro--image.image-4,
  .intro--image.image-2 {
    top: 50vh;
  }

  .intro--image.image-3,
  .intro--image.image-4 {
    background: transparent;
  }

  .intro--image .image {
    aspect-ratio: 1 / 1;
    display: block;
    height: auto;
    max-width: 350px;
    width: 100%;
  }

  .intro--image header {
    background: transparent;
    display: block;
    left: 50%;
    position: absolute;
    bottom: 10%;
    transform-origin: center center;
    transform: translate3d(-50%, 0, 0) rotate(-5deg);
    z-index: 5;
  }

  .intro--image.image-4 header {
    bottom: auto;
    top: 10%;
  }

  .intro--image h2,
  .intro--image h3 {
    background: var(--light);
    box-shadow: 0 0 0 2px var(--light);
    line-height: 1;
    margin: 0;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .intro--image h2 {
    color: var(--clean);
  }

  .intro--image.image-3 h2 {
    color: var(--meloni);
  }

  .intro--image.image-4 h2 {
    color: var(--schlein);
  }

  .intro--image h3 {
    font-size: 12px;
  }

  @media screen and (min-width:768px) {
    #intro {
      margin: 0 auto;
      max-width: 960px;
    }

    .intro--image .image {
      max-width: 420px;
      width: 60%;
    }

    .intro--image h2 {
      font-size: 36px;
    }

    .intro--image h3 {
      font-size: 24px;
    }
  }

  @media screen and (min-width:1024px) {
    .intro--image {
      height: 50vh;
      overflow: hidden;
      width: 50%;
    }

    .intro--image.image-1 {
      box-shadow: 480px 0 0 0 var(--light),
        0 250px 0 0 var(--light);
    }

    .intro--image.image-2 {
      box-shadow: 0 250px 0 0 var(--light);
    }

    .intro--image.image-4 header {
      bottom: 10%;
      top: auto;
    }

    .intro--image.image-4,
    .intro--image.image-2 {
      margin-left: 50%;
      top: 0;
    }

    .intro--image.image-3,
    .intro--image.image-4 {
      background: transparent;
    }

    .intro--image .image {
      width: 80%;
    }

    .text-2 {
      height: 50vh;
      top: 50vh;
    }
  }

  @media screen and (min-width:1280px) {
    .intro--image,
    .intro--text {
      padding: 40px 0;
    }
  }

  @media screen and (min-width:1680px) {
    .intro--image.image-4 header,
    .intro--image header {
      bottom: 25%;
    }
  }

  .note {
    background: yellow;
    border-radius: 3px;
    display: block;
    left: 50%;
    padding: 10px;
    position: absolute;
    transform: translate3d(-50%, 0, 0);
    top: 10px;
  }

  .note h3 {
    font-size: 16px;
    margin: 0;
  }

  .note p {
    font-size: 16px;
    margin: 0;
  }
</style>